"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Timer_1 = require("./Timer");
exports.default = Timer_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Timer/index.js
// module id = 1824
// module chunks = 8